import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { H7 } from 'foundations-components/transitional/components/H7';
import { View } from 'foundations-components/transitional/components/View';
import { ViewController } from 'foundations-components/transitional/components/ViewController';
import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
import ContentOverview from '../../../components/MostPopularCertificates/ContentOverview';
import SectionHeading from '../../../components/SectionHeading';
import OverviewModalAssessmentQuizMeContainer from '../../interactiveEducation/components/preAssessment/OverviewModalAssessmentQuizMeContainer';
//@ts-expect-error Could not find declaration file for module
import useMediaQuery from '../../../hooks/useMediaQuery';
import { EnrollLessonButton, EnrollTrackButton } from '../../userProgress/components/EnrollButton';
import { ModalTileSection } from '../../../components/TrackLessonOverviewModal/subcomponents/ModalTileSection';
import { device } from '../../../constants/StyledComponentConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BackgroundWrapper = ({
  children,
  isPlaylistOverview
}) => {
  if (isPlaylistOverview) {
    return /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-recessed",
      borderRadius: "300",
      padding: "800",
      children: children
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export const OverviewModalDescriptionSection = ({
  title,
  description,
  duration,
  enrollToUrl,
  selectedLanguage,
  availableLanguages,
  onChangeSelectedLanguage,
  contentList,
  hasCertificate,
  hasStudyGuide,
  isPlaylistOverview,
  type,
  id,
  onEnroll
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  // isQuizMeEnabled is a search param if set to true, the pre-assessment quiz me feature will be enabled within the overview modal. For now its only enabled for lessons overview modal.
  const [{
    isQuizMeEnabled
  }] = useSearchParams();
  const isPreAssessmentEnabled = isQuizMeEnabled === 'true';
  return /*#__PURE__*/_jsxs(View, {
    children: [isPreAssessmentEnabled && type === 'LESSON' ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ModalTileSection, {
        paddingBlockEnd: "400",
        paddingBlockStart: "800",
        paddingInline: "0",
        children: /*#__PURE__*/_jsx(Text, {
          as: isMobile ? 'h4' : 'h1',
          marginBlockEnd: "400",
          children: title
        })
      }), id && /*#__PURE__*/_jsx(OverviewModalAssessmentQuizMeContainer, {
        contentId: id,
        contentType: type,
        onEnroll: onEnroll
      })]
    }) : /*#__PURE__*/_jsxs(ModalTileSection, {
      padding: "0",
      paddingBlockStart: "800",
      children: [/*#__PURE__*/_jsx(Text, {
        as: isMobile ? 'h4' : 'h2',
        marginBlockEnd: "400",
        typography: "heading-600",
        children: title
      }), type === 'TRACK' ? /*#__PURE__*/_jsx(EnrollTrackButton, {
        id: id || 0,
        language: selectedLanguage,
        onEnroll: onEnroll,
        to: enrollToUrl
      }) : /*#__PURE__*/_jsx(EnrollLessonButton, {
        id: id || 0,
        language: selectedLanguage,
        onEnroll: onEnroll,
        to: enrollToUrl
      })]
    }), /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SectionHeading, {
        "data-test-id": type === 'LESSON' ? 'lesson-details' : 'course-details',
        paddingBlockEnd: "400",
        paddingBlockStart: "800",
        children: type === 'LESSON' ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.overviewModal.lessonDetails"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.overviewModal.courseDetails"
        })
      }), /*#__PURE__*/_jsx(BackgroundWrapper, {
        isPlaylistOverview: !!isPlaylistOverview,
        children: /*#__PURE__*/_jsxs(CardWrapper, {
          marginBlockEnd: "0",
          children: [/*#__PURE__*/_jsxs(ModalTileSection, {
            paddingBlockEnd: "600",
            children: [/*#__PURE__*/_jsx(H7, {
              paddingBlockEnd: "200",
              children: duration
            }), description]
          }), availableLanguages && availableLanguages.length > 0 && /*#__PURE__*/_jsx(ModalTileSection, {
            paddingBlockEnd: "400",
            children: /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx(H7, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.overviewModal.languagesAvailable"
                })
              }), /*#__PURE__*/_jsx(ViewController, {
                "data-test-id": "language-view-controller",
                onChange: onChangeSelectedLanguage,
                options: availableLanguages.map(lang => ({
                  text: lang.toUpperCase(),
                  value: lang
                })),
                size: "extra-small",
                value: selectedLanguage
              })]
            })
          }), type !== 'SHORT_FORM_CONTENT' && /*#__PURE__*/_jsxs(ModalTileSection, {
            children: [/*#__PURE__*/_jsx(H7, {
              marginBlockEnd: "100",
              marginBlockStart: "300",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.mostPopularCertificates.includes"
              })
            }), /*#__PURE__*/_jsx(ContentOverview, {
              content: contentList,
              hasCertificate: hasCertificate,
              hasStudyGuide: hasStudyGuide
            })]
          })]
        })
      })]
    })]
  });
};
export default OverviewModalDescriptionSection;